export const adjustmentDestination = {
    BANK_ACCOUNT: {label:'BANK ACCOUNT', value:'BANK_ACCOUNT'},
    TRADING_ACCOUNT: {label:'TRADING ACCOUNT', value:'TRADING_ACCOUNT'},
    CLIENT_TRADING_ACCOUNT: {label:'CLIENT TRADING ACCOUNT', value:'CLIENT_TRADING_ACCOUNT'},
}

export const adjustmentStatus = {
    REQUESTED_WITHDRAWAL: {label:'REQUESTED WITHDRAWAL', value:'REQUESTED_WITHDRAWAL'},
    APPROVED: {label:'APPROVED', value:'APPROVED'},
    DECLINED: {label:'DECLINED', value:'DECLINED'},
}

export const transactionDestination = {
    BANK_ACCOUNT: {label:'BANK ACCOUNT', value:'BANK_ACCOUNT'},
    TRADING_ACCOUNT: {label:'TRADING ACCOUNT', value:'TRADING_ACCOUNT'},
    CLIENT_TRADING_ACCOUNT: {label:'CLIENT TRADING ACCOUNT', value:'CLIENT_TRADING_ACCOUNT'},
}

export const transactionStatus = {
    REQUESTED_WITHDRAWAL: {label:'REQUESTED WITHDRAWAL', value:'REQUESTED_WITHDRAWAL'},
    APPROVED: {label:'APPROVED', value:'APPROVED'},
    DECLINED: {label:'DECLINED', value:'DECLINED'},
}

export const crPerType={
    PERLOT: {label:'PERLOT', value:'PERLOT'},
    PERMILLION: {label:'PERMILLION', value:'PERMILLION'},
}

export const mrPerType={
    PERLOT: {label:'PERLOT', value:'PERLOT'},
    PERMILLION: {label:'PERMILLION', value:'PERMILLION'},
}

export const symbolTypes={
    FOREX: {label:'FOREX', value:'FOREX'},
    INDEX: {label:'INDEX', value:'INDEX'},
    COMMODITY: {label:'COMMODITY', value:'COMMODITY'},
    SHARE: {label:'SHARE', value:'SHARE'},
    CRYPT: {label:'CRYPT', value:'CRYPT'},
    UNKNOWN: {label:'UNKNOWN', value:'UNKNOWN'},
    FUTURE: {label:'FUTURE', value:'FUTURE'},
}

export const yesNo={
    yes: {label: 'YES', value:true},
    no: {label: 'No', value:false}
}

export const entityPermissions = {
	//ALL_ENTITIES: 'All Entities',
	BASE_SYMBOLS: 'Base Symbols',
	SYMBOLS: 'Symbols',
	COMPANIES: 'Companies',
	IBS: 'Ibs',
    IB_TREES: 'Ib Trees',
	PROFILES: 'Profiles',
	CLIENTS: 'Clients',
	ACCOUNTS: 'Accounts',
	ADJUSTMENTS: 'Adjustments',
	WITHDRAWALS: 'Withdrawals',
	//PLATFORMS: 'Platforms',
	USERS: 'Users',
    IB_ACCOUNT_RULES: 'Ib Account Rules',
    //CURRENCIES: 'Currencies',
    CONTRACT_DETAILS_REPORT: 'Contract Details Report'
}


// WEBPACK FOOTER //
// ./src/enums/index.js